import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { isBankIdPerformed, isBankIdVerified } from "../../../../authentication/state/selectors";
import DsfMismatchFormContinueButton from "../../../../checkout/components/organisms/PersonalDetailsContinueButton/DsfMismatchFormContinueButton";
import { isTypeLoading } from "../../../../loading/state/selectors";
import { PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER } from "../../../state/actionTypes";
import TEXT from "../../../text-consts";

interface StateProps {
    isPerformed: boolean;
    isSubmittingOrder: boolean;
    isVerified: boolean;
}

type PersonalDetailsContinueButtonProps = StateProps;

const PersonalDetailsContinueButton: React.FC<PersonalDetailsContinueButtonProps> = ({
    isPerformed,
    isSubmittingOrder,
    isVerified,
}) => {
    if (isPerformed && !isVerified) {
        return <DsfMismatchFormContinueButton />;
    }

    if (!isPerformed) {
        return <></>;
    }

    return (
        <Button
            id="personal-details-form-button"
            form={FORM_ID.REGISTER_PREPAID}
            loading={isSubmittingOrder}
            disabled={!isVerified || isSubmittingOrder}
            type="submit"
        >
            {TEXT.BUTTON.ORDER}
        </Button>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    isPerformed: isBankIdPerformed(state),
    isSubmittingOrder: isTypeLoading(state, PREPAID_REGISTRATION_ADD_SIM_AND_PHONE_NUMBER),
    isVerified: isBankIdVerified(state),
});

export default connect(mapStateToProps)(PersonalDetailsContinueButton);
